// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"528":"daee21d5","672":"f87f883d","880":"0a442d40","941":"c748150b"}[chunkId] + ".js";
};